module.exports = __webpack_public_path__ + "static/media/close.050c8ca4.svg";